type ExcludeComponentPropsFunc = (...properties: PropertyKey[]) => {
    shouldForwardProp: (property: PropertyKey) => boolean;
};

export const excludeComponentProps: ExcludeComponentPropsFunc = (...props) => ({
    shouldForwardProp: (property): boolean => !props.includes(property)
});
